import { Dispatch, SetStateAction, useState } from 'react'
import { DragStart, DropResult } from 'react-beautiful-dnd'

import { DocumentType } from 'utils/constants/enums'

type DynamicTypeWithId<T> = {
  id: string
  type: string
} & T

export interface FolderList {
  createdAt: string
  deletedAt: string | null
  id: string
  name: string
  size: string
  type: DocumentType
  updatedAt: string
}

const useDragDropFiles = <T>(
  dataList: DynamicTypeWithId<T>[],
  setDataList: Dispatch<SetStateAction<any[]>>,
) => {
  const [draggedItem, setDraggedItem] = useState<DragStart>(null as any)
  const handleDragStart = (item: DragStart) => {
    setDraggedItem(item)
  }

  const handleDragOver = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.preventDefault()
  }

  const handleDrop = (
    item: DropResult,
    callback: (idStart: string, idEnd: string) => void,
  ) => {
    const dropIndex = item?.destination?.index
    if (dropIndex === undefined) {
      return
    }
    if (dataList[dropIndex].id === draggedItem.draggableId) {
      return
    }
    if (dataList[dropIndex]?.type === DocumentType.FOLDER) {
      const newDataList = dataList.filter(
        (item) => item?.id !== draggedItem?.draggableId,
      )
      setDataList(newDataList)
      callback(draggedItem.draggableId, dataList[dropIndex]?.id)
    }
  }

  return { handleDragStart, handleDragOver, handleDrop }
}

export default useDragDropFiles
